import { render, staticRenderFns } from "./GuestRelationsVenueOverview.vue?vue&type=template&id=08a7d532&scoped=true&"
import script from "./GuestRelationsVenueOverview.vue?vue&type=script&lang=js&"
export * from "./GuestRelationsVenueOverview.vue?vue&type=script&lang=js&"
import style0 from "./GuestRelationsVenueOverview.vue?vue&type=style&index=0&id=08a7d532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7d532",
  null
  
)

export default component.exports